<app-navbar [navList]="navList"></app-navbar>
<div class="qai-content-box overflow-auto">
  <div class="card qai-card qai-card-create shadow-sm">
    <div class="card-body px-4">
      <h4 class="card-title py-3">Nuovo Gruppo</h4>

      <form [formGroup]="groupForm" (ngSubmit)="onSubmit()">

        <div class="row mb-3">

          <div class="row mb-3">
            <div class="col-md-5">
              <label for="name" class="form-label">Nome</label>
              <input type="text" class="form-control" id="name" formControlName="name"
                [class.is-invalid]="name?.touched && name?.invalid">
              @if ((name?.touched || name?.dirty) && name?.invalid) {
                <div class="text-danger">
                  @if (name?.hasError('required')) {
                    <div>Nome è obbligatorio.</div>
                  }
                  @if (name?.hasError('maxlength')) {
                    <div>Lunghezza Massima 255.</div>
                  }
                </div>
              }
            </div>
          </div>

          <div class="row mb-3">
            <div class="col">
              <label for="description" class="form-label">Descrizione</label>
              <textarea class="form-control" id="description" formControlName="description" rows="4"
              [class.is-invalid]="description?.touched && description?.invalid"></textarea>
              @if ((description?.touched || description?.dirty) && description?.invalid) {
                <div
                  class="text-danger">
                  @if (description?.hasError('maxlength')) {
                    <div>Lunghezza Massima 255.</div>
                  }
                </div>
              }
            </div>
          </div>

        </div>

        <div class="d-flex justify-content-end">
          <app-loading-button class="me-3" [loading]="loading" [disabled]="groupForm.invalid || loading"
          i18n>Crea Gruppo</app-loading-button>
          <button type="button" class="btn btn-secondary" (click)="onCancel()" i18n>Annulla</button>
        </div>
      </form>
    </div>
  </div>
</div>